var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-update-site-message-1'),_c('b-container',{staticClass:"my-5",attrs:{"fluid":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }